import React, { useMemo } from 'react'
import useQueryGetUserChart from '@/api/user/getUserChart.ts'
import useQueryGetUserRecentState from '@/api/user/getUserRecentState.ts'
import DailyChart from '@/pages/users/detail/DailyChart.tsx'
import RealtimeChart from '@/pages/users/detail/RealtimeChart.tsx'
import useQueryGetUserChart10Minutes from '@/api/user/getUserChart10Minutes.ts'
import { useTranslation } from 'react-i18next'

export interface IProps {
    className?: string
    id: number
}

const RespirationChartContainer: React.FC<IProps> = ({ className, id }) => {
    const { t } = useTranslation()

    const { data: dailyData } = useQueryGetUserChart(id || -1)
    const { data: tenMinuteData } = useQueryGetUserChart10Minutes(id || -1)
    const { data: recent } = useQueryGetUserRecentState(id || -1)

    const dailySortedItems = useMemo(() => {
        const values: any[] = []

        dailyData?.respiration?.forEach(item => {
            values?.push({ x: item.x, y: item.y, yMin: item.yMin, yMax: item.yMax, range: [item.yMin, item.yMax] })
        })

        return values
    }, [dailyData])


    const tenMinuteSortedItems = useMemo(() => {
        const values: any[] = []

        tenMinuteData?.respiration?.forEach(item => {
            values?.push({ x: item.x, y: item.y, yMin: item.yMin, yMax: item.yMax, range: [item.yMin, item.yMax] })
        })

        return values
    }, [tenMinuteData])


    return <div className={`${className} py-[40px] px-[34px] flex gap-[3px]`}>
        {dailySortedItems.length > 0 ?
            <>
                <DailyChart className={'flex flex-1'} data={dailySortedItems} min={recent?.respBound?.at(0)}
                            max={recent?.respBound?.at(1)} unit={''} />
                <RealtimeChart className={'flex flex-1'} data={tenMinuteSortedItems} min={recent?.respBound?.at(0)}
                               max={recent?.respBound?.at(1)} unit={''} />
            </> :
            <>
                <div className={'h-[300px] flex-1 flex items-center justify-center'}>
                    <p className={'text-body'}>{t('users.detail.respiration.empty')}</p>
                </div>
            </>}
    </div>
}

export default RespirationChartContainer